var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{on:{"click":_vm.facebookLogin}},[_c('user-fb-button',{attrs:{"loading":_vm.loading}},[_vm._v("\n    "+_vm._s(_vm.$t('common.cta_facebook_login'))+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }